import { render } from "./ThumbnailIcon.vue?vue&type=template&id=5bebd934"
const script = {}
script.render = render

export default script